import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import {
  Section,
  SectionBgWrap,
  SectionPageTitle,
  SectionDescription,
  FlexWrap,
  LeftWrap,
} from "../../components/Section";

const HeroSection = styled(Section)`
  height: auto;
  margin-bottom: -70px;
  .container {
    z-index: 3;
    .partners-wrap {
      flex-direction: row-reverse;
      justify-content: flex-end;

      .gatsby-image-wrapper {
        margin-right: 40px;
      }
    }
  }

  @media (max-width: 768px) {
    .container {
      .partners-wrap {
        .gatsby-image-wrapper {
          margin-bottom: 40px;
        }
      }
    }
  }
`;

const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0)
  );
`;

const FinancingHero = ({ data, partners }) => (
  <HeroSection pt="68px" zIndex="0">
    <SectionBgWrap mOpacity="0.2">
      <GatsbyImage
        image={getImage(data.image.gatsbyImageData)}
        alt={data.title}
      />
    </SectionBgWrap>
    <Mask />
    <div className="container">
      <FlexWrap>
        <LeftWrap>
          <SectionPageTitle textAlign="left">{data.title}</SectionPageTitle>
          <SectionDescription textAlign="left">
            {data.description}
          </SectionDescription>
          {partners && (
            <FlexWrap className="partners-wrap">
              {partners.map((item) => (
                <GatsbyImage
                  image={getImage(item.gatsbyImageData)}
                  alt="GreenSky"
                />
              ))}
            </FlexWrap>
          )}
        </LeftWrap>
        <div></div>
      </FlexWrap>
    </div>
  </HeroSection>
);

export default FinancingHero;
